/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 19. CODEモードを使ってみよう */
export const template19 = {
  title: t.to('コードモード', 'title19'),
  desc: t.to(
    `CODEのタブでVRやAR空間に作用するJavaScriptのプログラムを書くことができます`,
    'desc19'
  ),
  img: '../public/template/19.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="190" y="130">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="cube_v2">
        <field name="id">block</field>
        <field name="position-x">0</field>
        <field name="position-y">1</field>
        <field name="position-z">0</field>
        <value name="COLOUR">
          <shadow type="color_value_v2">
            <field name="COLOUR">#97903e</field>
          </shadow>
        </value>
        <next>
          <block type="environment_v2">
            <field name="environment">preset:default</field>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>

  `,
  js_code: `const block = document.querySelector("#block")
forever(()=>{
    block.object3D.rotation.y += 0.1
})
`,
};
